import { render, staticRenderFns } from "./productsNews.vue?vue&type=template&id=5b231fbd&scoped=true&"
import script from "./productsNews.vue?vue&type=script&lang=js&"
export * from "./productsNews.vue?vue&type=script&lang=js&"
import style0 from "./productsNews.vue?vue&type=style&index=0&id=5b231fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b231fbd",
  null
  
)

export default component.exports